import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { scrollToSection } from '../utils/scrollToSection';

const NAV_ITEMS = [
  { label: 'Úvod', id: 'domů' },
  { label: 'Právní služby', id: 'služby' },
  { label: 'O advokátce', id: 'o-mně' },
  { label: 'Kontakt', id: 'kontakt' },
];

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id) => {
    scrollToSection(id);
    setIsMenuOpen(false);
  };

  const solid = scrolled || isMenuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? 'bg-paper border-b border-ink/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="flex h-16 sm:h-20 items-center justify-between">
          <button
            onClick={() => handleNavClick('domů')}
            className="text-left"
            aria-label="Přejít na úvod stránky"
          >
            <span
              className={`block font-serif text-lg sm:text-xl leading-none ${
                solid ? 'text-ink' : 'text-white'
              }`}
            >
              Lenka Ježková
            </span>
            <span
              className={`mt-1 block text-[10px] sm:text-[11px] uppercase tracking-[0.22em] ${
                solid ? 'text-bronze' : 'text-bronze-light'
              }`}
            >
              Advokátní kancelář
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-1" aria-label="Hlavní navigace">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`relative px-4 py-2 text-sm tracking-wide transition-colors after:absolute after:bottom-0 after:left-4 after:right-4 after:h-px after:origin-left after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100 ${
                  solid
                    ? 'text-ink/80 after:bg-bronze hover:text-bronze'
                    : 'text-white/85 after:bg-bronze-light hover:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
            <a
              href="tel:+420721207779"
              className={`ml-4 flex items-center gap-2 border px-4 py-2 text-sm font-medium transition-colors ${
                solid
                  ? 'border-ink/25 text-ink hover:border-bronze hover:text-bronze'
                  : 'border-white/30 text-white hover:border-white/70'
              }`}
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              <span>721 207 779</span>
            </a>
          </nav>

          <button
            className={`md:hidden -mr-2 p-2.5 ${solid ? 'text-ink' : 'text-white'}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? 'Zavřít menu' : 'Otevřít menu'}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <nav
          className="md:hidden border-t border-ink/10 bg-paper"
          aria-label="Mobilní navigace"
        >
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className="block w-full border-b border-ink/5 px-5 py-4 text-left text-base text-ink/90"
            >
              {item.label}
            </button>
          ))}
          <div className="p-5">
            <a
              href="tel:+420721207779"
              className="flex items-center justify-center gap-2 bg-ink px-5 py-3.5 text-base font-medium text-white"
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              <span>Zavolat: 721 207 779</span>
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
